import Common from "./common.js";
import "../../scss/v5/movie.scss";
import JustWatchAPI from "./components/JustWatchAPI.js";
import YouTubeHoverPreview from "./components/YouTubeHoverPreview.js";
import VideoFacade from "./components/VideoFacade.js";
import MovieShowtimes from "./components/MovieShowtimes.js";
import MoviePicturesLightbox from "./components/MoviePicturesLightbox.js";
import SimilarMovies from "./components/SimilarMovies.js";
import WatchlistToggle from "./components/WatchlistToggle.js";
import JustWatchButton from "./components/JustWatchButton.js";

Common.initPage(async (consentPromise) => {
  const movieId = document.querySelector("h1.movie-title").id.split("-")[1];

  WatchlistToggle(document.querySelector(".add-to-watchlist-button")).mount();

  MoviePicturesLightbox({
    picturesSelector: ".movie-pictures",
  }).mount();

  MovieShowtimes({
    showtimesSelector: "#movie-showtimes-first",
    showtimesRestSelector: "#movie-showtimes-rest",
    showtimesLoadButtonSelector: "#movie-showtimes-first .list-more",
    showtimesRestToggleCheckboxSelector: "#movie-showtimes-toggle-rest",
    movieId: movieId,
  }).mount();

  JustWatchAPI({
    ratingSelector: ".movie-rating.justwatch-rating",
    widgetSelector: ".movie-justwatch",
    preloadScriptId: "__justwatch_preload",
  }).render();

  JustWatchButton({
    movieId,
    streamingButton: document.querySelector(".button.streaming"),
  }).mount();

  // Smooth scroll for media links with navbar offset
  const NAVBAR_HEIGHT = 48; // headerNavbarHeight from _header.scss
  const SCROLL_OFFSET = NAVBAR_HEIGHT + 16; // navbar + some padding

  document.querySelectorAll('.movie-v2-media-links a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  });

  // Initialize YouTube hover previews
  document.querySelectorAll(".trailer-list li[data-youtube-id]").forEach((item) => {
    YouTubeHoverPreview(item).mount();
  });

  // Initialize video facades (click-to-load for iframes)
  document.querySelectorAll(".video-facade").forEach((facade) => {
    VideoFacade(facade, consentPromise).mount();
  });

  // Initialize similar movies
  const similarMoviesContainer = document.querySelector("#similar-movies");
  if (similarMoviesContainer) {
    SimilarMovies(similarMoviesContainer).mount();
  }
});
